export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000/api";

export const API_PATHS = {
  AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
    PROFILE: "/auth/profile",
    SETUP: "/auth/setup",
    SETUP_STATUS: "/auth/setup-status",
  },
  USER: {
    PROFILE: "/users/profile",
    UPDATE: "/users/update",
  },
  // Add other modules here
};

export const getApiPath = (path: string) => `${API_BASE_URL}${path}`;
